import { render } from "./Musicals.vue?vue&type=template&id=3377a888&ts=true"
import script from "./Musicals.vue?vue&type=script&lang=ts"
export * from "./Musicals.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/chronicle/chronicle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__